import axios from "axios";
import {
  activeRolesRequested,
  activeRolesRequestSucceeded,
  activeRolesRequestFailed,
} from "../slices/GetActiveRolesByCountrySlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Rol/GetActiveByCountry?country=${encodeURIComponent(selectedCountry)}`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const GetActiveRolesByCountry = () => async (dispatch) => {
  try {
    dispatch(activeRolesRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(activeRolesRequestSucceeded(response.data));
  } catch (error) {
    dispatch(activeRolesRequestFailed(error.message));
  }
};
